
import styled from 'styled-components';
import MarkdownParser from '@/components/molecules/MarkdownParser';
import devices from '@/utilities/devices';

export const TextWithImageContainer = styled.div<{ backgroundImage: string, blockOrientation: string, isTextWhite?: boolean }>`
	display: flex;
	flex-direction: ${({ blockOrientation }) => blockOrientation};
	margin-bottom: 2rem;
	margin-top: 2rem;
	color: ${({ isTextWhite, theme }) => isTextWhite ? theme.color.white : theme.color.black};

	.left-container {
		align-items: flex-start;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		width: 65%;
	}

	.right-container {
		background-image: url(${({ backgroundImage }) =>  backgroundImage });
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		height: 20rem;
		margin-top: 2.5rem;
		position: relative;
		width: 35%;
		z-index: 0;
		@media (min-device-pixel-ratio: 1.5), (min-resolution: 144dpi) {
			background-image: url(${({ backgroundImage }) => backgroundImage });
		}
	}

		@media screen and (${devices.mobile}) {
			flex-direction: column-reverse;
			margin-bottom: 0;
			margin-top: 0;
			min-height: auto;
			padding: 0 1rem;
			.left-container {
				align-items: center;
				padding: 0;
				width: 100%;
			}
			.right-container {
				background-image: url(${({ backgroundImage }) => backgroundImage });
				margin-top: 0;
				width: 100%;
			}
		}
		@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
			flex-direction: column-reverse;
			margin-bottom: 0;
			margin-top: 0;
			min-height: auto;
			padding: 0 1rem;
			.left-container {
				align-items: center;
				padding: 0;
				width: 100%;
			}
			.right-container {
				background-image: url(${({ backgroundImage }) => backgroundImage });
				margin-top: 0;
				width: 100%;
			}
		}
`;

const TextWithImage = ({ backgroundImage, blockOrientation, isTextWhite, children }: {
	backgroundImage: string;
	blockOrientation: 'row' | 'row-reverse';
	isTextWhite?: boolean;
	children: any;
}) => {
	return (
		<TextWithImageContainer
			backgroundImage={backgroundImage}
			blockOrientation={blockOrientation}
			isTextWhite={isTextWhite}
		>
			<div className='left-container'>
				<MarkdownParser padding={{ top: '.5rem', bottom: '2rem' }}>
					{children}
				</MarkdownParser>
			</div>
			<div className='right-container'></div>
		</TextWithImageContainer>
	);
};

export default TextWithImage;
